import { FilterCounterOverride } from 'components/filters/FilterIconWithCounterFromForm';

/**
 * Property status filters default to a status other than "All" (empty string),
 * so the filter is applied before the field ever becomes dirty.
 */
export const PROPERTY_STATUS_FILTER_COUNTER_OVERRIDES = [
  { name: 'status', getCount: (value: unknown) => (value === '' ? 0 : 1) },
] as const satisfies FilterCounterOverride[];
